class BaseReducer {
  getActionType = () => `[${this.domain}] ${this.type}`;

  map = () => {
    return { [this.getPath()]: this.getReducer() };
  };

  getPath = () => this.domain + "_" + this.type;

  getReducer = () => {
    return (state = this.initialState, action) => {
      switch (action.type) {
        case this.getActionType():
          return { ...state, ...action.payload };
        default:
          return state;
      }
    };
  };
}

export default BaseReducer;
